module.exports = __webpack_public_path__ + "img/top-configuration-trigger.7e36cd07.svg";